<template>
  <nav class="tab-menu-container" role="navigation">
    <div class="hamburger-menu-container" v-click-outside="closeMobileMenu">
      <button type="button" @click="displayMobileMenu()" class="hamburger-button" aria-haspopup="menu" :aria-expanded="toggleMenu">
        <img
          class="hamburger-icon"
          src="@Shared/assets/images/bars-solid.svg"
          alt="hamburger-bars-menu"
        />
      </button>
      <focus-trap :active="toggleMenu" :initial-focus="getFirstTab" v-if="toggleMenu">
        <div role="menu">
          <ul class="mobile-menu-container" ref="mobileMenu">
            <li
              v-for="(tab, index) in tabMenuItems"
              v-bind:key="index"
              class="tab-mobile-menu-items"
              :aria-label="'Account Navigation'"
            >
              <TabMenuItem class="hamburger-tab" :tab="tab" @closeMobileMenu="closeMobileMenu" role="link" />
            </li>
          </ul>
        </div>
      </focus-trap>
    </div>
    <ul class="desktop-menu-container">
      <li
        v-for="(tab, index) in tabMenuItems"
        v-bind:key="index"
        class="tab-menu-items"
        :aria-label="'Account Navigation'"
      >
        <TabMenuItem :tab="tab" />
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import TabMenuItem from "./TabMenuItem.vue";

export default {
  name: "TabMenu",
  components: {
    TabMenuItem
  },
  directives: {
    "click-outside": {
      bind(el, binding) {
        el.clickOutsideHandler = event => {
          if (!el.contains(event.target)) {
            binding.value();
          }
        };
        document.addEventListener("click", el.clickOutsideHandler);
      },
      unbind(el) {
        document.removeEventListener("click", el.clickOutsideHandler);
      }
    }
  },
  props: {
    tabMenuItems: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    toggleMenu: false
  }),
  computed: {
    ...mapGetters(["accountSummary"])
  },
  methods: {
    ...mapActions(["setTabMenuItems"]),
    displayMobileMenu() {
      this.toggleMenu = !this.toggleMenu;
    },
    closeMobileMenu() {
      this.toggleMenu = false;
    },
    getFirstTab() {
      return document.querySelectorAll("div.hamburger-tab > button.tab-title")[0];
    }
  },
  mounted() {
    if (this.tabMenuItems.length === 0) {
      if (this.$route.name === "Sorry") {
        this.setTabMenuItems("Sorry", {}, this.$route.params);
      } else {
        this.setTabMenuItems("AccountSummary", {}, {});
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// Got some help with the hamburger menu from codepen.io/erikterwan/pen/EVzeRP
.tab-menu-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-right: 75px;

  @media (max-width: 1100px) {
    justify-content: end;
  }
  @media (max-width: $grid-breakpoint-sm) {
    margin-bottom: 18px;
  }

  .tab-menu-items {
    display: flex;
    flex-direction: row;
    gap: 15px;
  }

  .tab-menu-items:hover, .tab-menu-items:has(.tab-title:focus-visible) {
    background-color: rgba(244, 243, 241, 1);
  }

  .desktop-menu-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 2px;

    @media (max-width: 1100px) {
      display: none;
    }
  }

  .hamburger-menu-container {
    display: none;

    @media (max-width: 1100px) {
      display: flex;
      width: 150px;
      height: 150px;
      flex-direction: column;
      place-items: flex-end;
      position: absolute;
      right: 7%;
      top: 45px;
      row-gap: 20px;
      z-index: 950;
    }

    @media (max-width: $grid-breakpoint-sm) {
      right: 25px;
      top: unset;
    }

    .hamburger-button {
      border: none;
      background: none;
      padding: 0px;
      width: fit-content;
      outline-offset: 5px;
      display: flex;
      align-items: center;
    }

    .mobile-menu-container {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 10px;
      position: relative;
      background: #ffffff;
      border: 1px solid #e9eaea;
      box-shadow: 0px 4px 8px rgba(30, 30, 37, 0.16),
        0px 2px 4px -1px rgba(30, 30, 37, 0.1);
      border-radius: 10px;

      li, .hamburger-tab {
        width: 100%;
      }
    }
  }
}
</style>
